// extracted by mini-css-extract-plugin
module.exports = {"map":"MapComponent_map__Z-0kL"};